import React, { Component } from 'react';
import { Modal, Form, Input, Select, Icon, Button, Checkbox } from 'antd';

class LoginModal extends Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            userName: "",
            password: ""
        }
        this.loginInputUserName = React.createRef();
        this.onClickLoginRegister = this.onClickLoginRegister.bind(this);
        this.onEditUserName = this.onEditUserName.bind(this);
        this.onEditPassword = this.onEditPassword.bind(this);
    }

    componentWillReceiveProps(theProps) {

    }

    componentDidMount() {
        console.log("loginmodal did mount")
    }

    componentWillUnmount(){
        document.getElementById("login_input_user_name").value = " ";
        document.getElementById("login_input_password").value = " ";
    }

    showLoginModal = () => {
        this.setState({
            visible: true,
            userName: "",
            password: ""
        });
        setTimeout(()=>{document.getElementById("login_input_user_name") && document.getElementById("login_input_user_name").focus()}, 366);
        setTimeout(()=>{try{document.getElementById("login_input_user_name").value = ""; document.getElementById("login_input_password").value = "";}catch(e){}}, 366);
    }

    handleOk = (e) => {
        this.props.validateLogin(document.getElementById("login_input_user_name").value, document.getElementById("login_input_password").value);
        document.getElementById("login_input_user_name").value = "";
        document.getElementById("login_input_password").value = "";
        this.setState({
            visible: false,
            userName: "",
            password: ""
        });
        
    }

    handleCancel = (e) => {
        document.getElementById("login_input_user_name").value = "";
        document.getElementById("login_input_password").value = "";
        this.setState({
            visible: false,
            userName: "",
            password: ""
        });
    }

    isEmptyObj(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    onSelectProtocol(value, option) {
        this.selectedProtocol = value;
    }

    onClickLoginRegister(e) {
        this.setState({
            visible: false,
            userName: "",
            password: ""
        });
        this.props.openAddNewTenantModal(e);
    }

    onEditUserName(e){
        this.setState({ userName: e.target.value })
    }

    onEditPassword(e){
        this.setState({ password: e.target.value })
    }

    keyPress(e){
        if(e.keyCode == 13){
            this.props.validateLogin(document.getElementById("login_input_user_name").value, document.getElementById("login_input_password").value);
            document.getElementById("login_input_user_name").value = "";
            document.getElementById("login_input_password").value = "";
            setTimeout(()=>{this.setState({
                visible: false,
                userName: "",
                password: ""
            })}, 1);
        }
     }

    render() {
        // const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title="Login"
                maskClosable={false}
                visible={this.state.visible}
                okText="Login"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width={386} >
                <div>
                    <Form className="login-form">
                        <Form.Item>
                            <Input ref={this.loginInputUserName} id="login_input_user_name" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" value={this.state.userName} onChange={this.onEditUserName} onKeyDown={this.keyPress.bind(this)} />
                        </Form.Item>
                        <Form.Item>
                            <Input id="login_input_password" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" value={this.state.password} onChange={this.onEditPassword} onKeyDown={this.keyPress.bind(this)} />
                        </Form.Item>
                        <Form.Item style={{display: "none"}}>
                            <a className="login-form-forgot" >Forgot password</a>
                            &nbsp;Or&nbsp;
                            <a href="#" onClick={this.onClickLoginRegister} >Register now!</a>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

export default LoginModal;
